import { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { PrivacyRequestListParams } from '../api/privacy-requests-api';
import {
  PRIVACY_REQUEST_FILTER_FIELDS,
  PRIVACY_REQUEST_SORTS,
} from '../components/privacy-request-filters';

/** URL search params of the privacy requests list; mirrors GET /admin/v1/stores/{storeId}/privacy-requests. */
export const privacyRequestListSearchSchema = indexSearchSchema(PRIVACY_REQUEST_FILTER_FIELDS, {
  sort: PRIVACY_REQUEST_SORTS,
})
  // No text search on this endpoint. The router keeps a param the schema leaves out, so `q` is
  // read and thrown away instead.
  .extend({ q: z.undefined().catch(undefined) });

export type PrivacyRequestListSearch = z.infer<typeof privacyRequestListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function privacyRequestListParams(
  search: PrivacyRequestListSearch,
): PrivacyRequestListParams {
  return listParams(search, PRIVACY_REQUEST_FILTER_FIELDS);
}
